import React, { useMemo } from 'react';
import { Stack } from 'expo-router';
import { useResponsive } from '@sg/garnish';

import { Navbar } from '../../components';
import { HEADER_SCREEN_OPTIONS } from '../options';

// ─────────────────────────────────────────────────────────────────────────────

export default function AuthLayout() {
  const { currentBreakpoint } = useResponsive();

  const screenOptions = useMemo(
    () => ({
      ...HEADER_SCREEN_OPTIONS,
      headerShown: true,
      header: currentBreakpoint.isXS ? undefined : renderNavbar,
    }),
    [currentBreakpoint.isXS],
  );

  return (
    <Stack screenOptions={screenOptions}>
      <Stack.Screen name="join-or-sign-in/index" />
    </Stack>
  );
}

// ─── Helpers ─────────────────────────────────────────────────────────────────

function renderNavbar() {
  return <Navbar />;
}
